<template>
  <div>
    <div class="flex flex-col" v-show="imgUploader.imgs.length > 0">
      <div
        class="flex flex-col"
        style="margin-bottom: 28px"
        v-for="(img, i) in imgUploader.imgs"
        :key="i"
      >
        <div class="flex flex-row items-center">
          <app-input-status
            :label="`資料 ${i + 1}/${imgUploader.imgs.length}`"
            :optional="true"
            :status="1"
            :color="color"
          />
          <!-- <span :class="`text-${color} mb-1 ml-1`"
            >※画像クリックで拡大表示</span
          > -->
        </div>
        <div
          :class="
            `flex flex-col border border-${color} pl-2 pr-3 py-2 bg-white`
          "
        >
          <div class="ml-auto">
            <button
              :class="`inline-block mr-4 text-white bg-${color}`"
              style="border-radius:5px; height:25px; width:100px;"
              @click="
                openImgPreview('receipt', i, {
                  normalImage: currentReceipt.files[i].normalImage,
                  blackImage: currentReceipt.files[i].blackImage,
                })
              "
            >
              <svg
                class="inline-block"
                style="margin-bottom: 2px; margin-right: -5px;"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 3.07175C13.0434 2.51947 11.8202 2.84722 11.2679 3.8038L6.76793 11.598L10.232 13.598L14.732 5.8038C15.2843 4.84722 14.9566 3.62403 14 3.07175Z"
                  fill="white"
                />
                <path
                  d="M6.48232 17.0212C6.12762 17.3003 5.61387 17.0037 5.67824 16.557L6.26793 12.4641L9.73203 14.4641L6.48232 17.0212Z"
                  fill="white"
                />
              </svg>
              黒塗り
            </button>
            <!-- <button
              :class="`inline-block mr-4 text-white bg-${color}`"
              style="border-radius:5px; height:25px; width:100px;"
              @click.stop="openImgWarp(i)"
            >
              <span style="margin-left:-5px;">
                台形補正
              </span>
            </button> -->
            <button
              :class="`inline-block mr-4 text-white bg-${color}`"
              style="border-radius:5px; height:25px; width:100px;"
              @click.stop="openImgEditor(i)"
            >
              <span style="margin-left:-5px;">
                ✂︎切り抜き
              </span>
            </button>
            <svg
              class="inline-block"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="deleteImg(i)"
            >
              <circle
                cx="12"
                cy="12"
                r="11"
                fill="white"
                stroke="#549A1D"
                stroke-width="2"
              />
              <path
                d="M17.7071 7.70714C18.0976 7.31661 18.0976 6.68345 17.7071 6.29292C17.3166 5.9024 16.6834 5.9024 16.2929 6.29292L12 10.5858L7.70711 6.29293C7.31658 5.90241 6.68342 5.90241 6.29289 6.29293C5.90237 6.68346 5.90237 7.31662 6.29289 7.70714L10.5858 12L6.29289 16.2929C5.90237 16.6835 5.90237 17.3166 6.29289 17.7071C6.68342 18.0977 7.31658 18.0977 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0977 17.3166 18.0977 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70714Z"
                fill="#549A1D"
              />
            </svg>
          </div>
          <img
            class="object-contain w-full"
            style="height: 400px;"
            :src="
              currentReceipt.files[i].blackImage == null
                ? img
                : currentReceipt.files[i].blackImage
            "
          />
          <!-- 画像の切り抜き -->
          <TransitionRoot
            appear
            v-if="isImgEditorOpen && imageIndex === i"
            as="template"
          >
            <Dialog as="div">
              <div class="fixed inset-0 overflow-y-auto" style="z-index: 400">
                <DialogOverlay class="fixed inset-0 bg-black opacity-50" />
                <AppImageCropper
                  :source="imgUploader.imgs[i]"
                  :index="i"
                  :type="type"
                  :color="color"
                ></AppImageCropper>
              </div>
            </Dialog>
          </TransitionRoot>
          <!-- 画像の台形補正 -->
          <TransitionRoot
            appear
            v-if="isImgWarpOpen && imageIndex === i"
            as="template"
          >
            <Dialog as="div">
              <div class="fixed inset-0 overflow-y-auto" style="z-index: 400">
                <DialogOverlay class="fixed inset-0 bg-black opacity-50" />
                <AppImageWarp
                  :source="imgUploader.imgs[i]"
                  :index="i"
                  :type="type"
                  :color="color"
                ></AppImageWarp>
              </div>
            </Dialog>
          </TransitionRoot>
        </div>
      </div>
    </div>
    <slot name="uploaderInputStatus"> </slot>
    <div
      class="flex flex-row items-center"
      v-if="limitImageSize || limitPdfPage"
    >
      <rejected-icn
        width="18"
        height="18"
        class="mt-1.5 ml-1 mr-1"
        style="align-self: baseline;"
      />
      <span v-if="limitImageSize" class="text-red text-lg"
        >画像サイズを4MB以下にしてください</span
      >
      <span v-if="limitPdfPage" class="text-red text-lg"
        >複数ページのPDFには対応していません</span
      >
    </div>
    <div
      v-show="countImg() <= 1"
      :class="
        `flex flex-column h-96 border-dashed border-2 border-${color} rounded-full mb-4`
      "
      style="border-radius: 20px;"
      @dragover.prevent="dragOver"
      @dragleave.prevent="dragLeave"
      @drop.prevent="drop($event)"
      id="imageUploader"
    >
      <div class="flex flex-row mx-auto my-auto text-center h-10">
        <div class="flex flex-row items-center justify-center">
          <div class="flex flex-row items-baseline">
            <span :class="`text-${color} text-lg font-bold`">ファイル</span>
            <span :class="`text-${color} text-sm font-bold`">を</span>
            <span :class="`text-${color} text-lg font-bold`">ドロップ</span>
            <span :class="`text-${color} text-sm mx-1`">または</span>
          </div>
        </div>
        <div>
          <label
            for="file-upload"
            :class="
              `border-4 border-${color} h-10 rounded-full px-4 inline-flex items-center justify-center`
            "
          >
            <attach-icn
              width="20px"
              height="20px"
              :class="`${color}-icon`"
            ></attach-icn>
            <span :class="`text-${color} text-lg font-bold`">ファイル選択</span>
          </label>
          <input
            ref="inputImageOsaka"
            type="file"
            accept="image/png,image/jpeg,application/pdf"
            style="z-index: 1; display: none"
            @change="previewImgs"
            id="file-upload"
          />
          <canvas id="the-canvas" style="display:none;"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import PDFJS from 'pdfjs-dist'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppImageCropper from '@/components/ui/AppImageCropper'
import AppImageWarp from '@/components/ui/AppImageWarp'
import AttachIcn from '@/assets/icons/attach.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import { TransitionRoot, Dialog, DialogOverlay } from '@headlessui/vue'
import { useImgUploader } from '@/services/useImgUploader'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useReceipts } from '@/services/receiptsOsaka/useReceipts'
import { useMemoryItemForm } from '@/services/politicalAction/useMemoryItemForm'
import { useDialog } from '@/services/useDialog'

export default {
  name: 'AppImageUploader_OSAKA',

  emits: ['changed'],

  components: {
    AttachIcn,
    RejectedIcn,
    AppInputStatus,
    AppImageCropper,
    AppImageWarp,
    Dialog,
    DialogOverlay,
    TransitionRoot,
  },

  props: {
    color: String,
    type: String,
  },

  setup(props, { emit }) {
    const PdfjsWorker = require('worker-loader?esModule=false&filename=[name].[contenthash].js!pdfjs-dist/build/pdf.worker.js')
    PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker()
    PDFJS.GlobalWorkerOptions.workerSrc =
      '//mozilla.github.io/pdf.js/build/pdf.worker.js'
    let {
      imgUploader,
      isImgEditorOpen,
      openImgEditor,
      isImgWarpOpen,
      openImgWarp,
      imageIndex,
    } = useImgUploader()
    const { currentPoliticalAction } = usePoliticalActions()
    const { currentReceipt } = useReceipts()
    const { images } = useMemoryItemForm()
    const limitImageSize = ref(false)
    const limitPdfPage = ref(false)
    const { isImgPreviewOpen, openImgPreview } = useDialog()
    const inputImageOsaka = ref()

    watch(isImgPreviewOpen, () => {
      if (!isImgPreviewOpen.value) {
        for (let i = 0; i < currentReceipt.files.length; i++) {
          if (currentReceipt.files[i].blackImage !== null) {
            imgUploader.imgs[i] = currentReceipt.files[i].blackImage
          }
        }
      }
    })

    const dragOver = () => {
      imgUploader.dropped = 2
    }

    const dragLeave = () => {}

    const drop = e => {
      let files = Array.from(e.dataTransfer.files)
      if (e && files) {
        let status = true
        files.forEach(file => {
          if (
            file.type.startsWith('image/png') === false &&
            file.type.startsWith('image/jpeg') === false &&
            file.type.startsWith('application/pdf') === false
          )
            status = false
        })
        if (status == true) {
          imgUploader.files.push(...files)
          previewImgs()
          // if (files.legtn > 0)
        }
      }
      imgUploader.dropped = 0
    }

    const readAsDataURL = file => {
      return new Promise(function(resolve, reject) {
        let fr = new FileReader()
        fr.onload = function() {
          resolve(fr.result)
        }
        fr.onerror = function() {
          reject(fr)
        }
        fr.readAsDataURL(file)
      })
    }

    const previewImgs = e => {
      if (imgUploader.dropped == false)
        imgUploader.files.push(...e.currentTarget.files)

      let readers = []

      emit('changed', imgUploader.files)

      if (!imgUploader.files.length) return
      checkImageSize()
      for (let i = 0; i < imgUploader.files.length; i++) {
        readers.push(readAsDataURL(imgUploader.files[i]))
      }
      Promise.all(readers).then(values => {
        const imageIndex = values.length - 1
        const addItem = {
          normalImage: values[imageIndex],
          blackImage: null,
        }
        if (limitImageSize.value) {
          return
        } else if (
          addItem.normalImage.indexOf('data:application/pdf;base64,') === 0
        ) {
          uploadPdf(imgUploader.files)
        } else if (props.type === 'request') {
          currentPoliticalAction.application.images.push(addItem)
          imgUploader.imgs.push(values[imageIndex])
        } else if (props.type === 'result') {
          currentPoliticalAction.report.images.push(addItem)
          imgUploader.imgs.push(values[imageIndex])
        } else if (props.type === 'memory') {
          images.value.push(addItem)
          imgUploader.imgs.push(values[imageIndex])
        } else if (props.type === 'receipt') {
          currentReceipt.files.push(addItem)
          imgUploader.imgs.push(values[imageIndex])
        } else {
          return
        }
      })
      // changeイベントで同じ画像を連続して投稿できないため、画像を投稿するたびにinputのDOM要素のvalueを消す
      inputImageOsaka.value.value = ''
    }

    const deleteImg = index => {
      imgUploader.imgs.splice(index, 1)
      imgUploader.files.splice(index, 1)
      switch (props.type) {
        case 'request':
          currentPoliticalAction.application.images.splice(index, 1)
          break
        case 'result':
          currentPoliticalAction.report.images.splice(index, 1)
          break
        case 'memory':
          images.value.splice(index, 1)
          break
        case 'receipt':
          currentReceipt.files.splice(index, 1)
          break
        default:
          break
      }
      emit('changed', imgUploader.files)
    }

    const countImg = () => {
      if (props.type === 'request') {
        return currentPoliticalAction.application.images.length
      } else if (props.type === 'result') {
        return currentPoliticalAction.report.images.length
      } else if (props.type === 'memory') {
        return images.value.length
      } else if (props.type === 'receipt') {
        return currentReceipt.files.length
      }
    }

    const checkImageSize = () => {
      limitPdfPage.value = false
      limitImageSize.value = false
      imgUploader.files.forEach(file => {
        return (limitImageSize.value = file.size > 4194304)
      })
    }

    const readFileAsync = file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsArrayBuffer(file)
      })
    }

    const uploadPdf = async file => {
      const fileData = await readFileAsync(file[file.length - 1])
      const pdf = PDFJS.getDocument({
        data: fileData,
        cMapUrl: '/cmaps/',
        cMapPacked: true,
      })
      const loadingTask = pdf
      loadingTask.promise.then(
        function(pdf) {
          if (pdf._transport._numPages === 1) {
            // 表示するPDFのページナンバーを取得
            pdf.getPage(1).then(function(page) {
              //表示するPDFの大きさを取得(画像に変換した時に等倍だと画質が荒くなってしまうためサイズを２倍に設定)
              const viewport = page.getViewport({ scale: 2 })
              //PDFを表示に使うcanvasタグを取得(今回はPDFでの表示はしないためcanvasは非表示設定)
              const canvas = document.getElementById('the-canvas')
              //PDFレンダリング時に必要なコンテキストを作成
              const context = canvas.getContext('2d')
              canvas.height = viewport.height
              canvas.width = viewport.width
              //キャンバスにレンダリング
              const renderContext = {
                canvasContext: context,
                viewport: viewport,
              }
              const renderTask = page.render(renderContext)
              renderTask.promise.then(function() {
                //キャンバスからpngに変換
                const base64 = canvas.toDataURL('image/jpeg')
                const addItem = {
                  normalImage: base64,
                  blackImage: null,
                }
                if (props.type === 'request') {
                  currentPoliticalAction.application.images.push(addItem)
                  imgUploader.imgs.push(base64)
                } else if (props.type === 'result') {
                  currentPoliticalAction.report.images.push(addItem)
                  imgUploader.imgs.push(base64)
                } else if (props.type === 'memory') {
                  images.value.push(addItem)
                  imgUploader.imgs.push(base64)
                } else if (props.type === 'receipt') {
                  currentReceipt.files.push(addItem)
                  imgUploader.imgs.push(base64)
                } else {
                  return
                }
              })
            })
          } else {
            return (limitPdfPage.value = true)
            // PDFが１ページじゃない時にエラーメッセージを表示
          }
        },
        function(reason) {
          // PDF loading error
          console.error(reason)
        },
      )
    }

    return {
      imgUploader,
      dragOver,
      dragLeave,
      drop,
      previewImgs,
      deleteImg,
      countImg,
      checkImageSize,
      limitImageSize,
      limitPdfPage,
      uploadPdf,
      isImgEditorOpen,
      imageIndex,
      openImgEditor,
      isImgWarpOpen,
      openImgWarp,
      currentReceipt,
      isImgPreviewOpen,
      openImgPreview,
      inputImageOsaka,
    }
  },
}
</script>
<style lang="scss">
#imageUploader {
  background: white;
}
</style>
